import { ProductsConfig } from '../../../interfaces/mock.interface';

export const FAI_MOCK: ProductsConfig[] = [
    {
        label: 'Panenka',
        gencode: 'FAIFIBER#72156547',
    },
    {
        label: 'Otis',
        gencode: '72156888',
    },
    {
        label: 'FAI Ultym WIFI 7',
        gencode: '72157012',
    },
    {
        label: 'FAI Ultym (cypress)',
        gencode: '72156734',
    },
    {
        label: 'Pure Fibre',
        gencode: '72157034',
    },

    {
        label: 'SmartTV',
        gencode: '72156998',
    },
    {
        label: '4G Box',
        gencode: '6364',
    },
    {
        label: '5G Box',
        gencode: '6700',
    },
];
